module.exports = __webpack_public_path__ + "img/06_Schnupperangebot-Tabelle.5722b9b3.svg";